// src/api/dashboard.ts
import { api } from './index';

export interface DateRange {
  startDate?: string;
  endDate?: string;
}

export interface DailyProductWeightStats {
  date: string;
  count: number;
  totalWeight: number;
}

export interface ProductWeightStats {
  totalCount: number;
  totalWeight: number;
  dailyStats: DailyProductWeightStats[];
}

export interface CustomerStat {
  customerName: string;
  count: number;
  totalWeight: number;
}

export interface ProductStat {
  productName: string;
  count: number;
  totalWeight: number;
}

export interface ProductWeightSummary {
  period: {
    startDate: string;
    endDate: string;
  };
  totalCount: number;
  totalWeight: number;
  customerStats: CustomerStat[];
  productStats: ProductStat[];
}

export const dashboardService = {
  /**
   * Get product weight statistics
   */
  getProductWeightStats: (params?: DateRange) =>
    api.get<ProductWeightStats>('/dashboard/product-weight/stats', { params }),

  /**
   * Get product weight summary
   */
  getProductWeightSummary: (params?: DateRange) =>
    api.get<ProductWeightSummary>('/dashboard/product-weight/summary', { params }),
}; 